$(document).ready(function() {

    $(document).on('click', '.js-slider-close', function() {
        $('.b-slider__wrap').fadeOut(300);
    });
});


// WEBPACK FOOTER //
// ./src/js/pages/main/slider-close.js